import PhoneUtil from 'gw-portals-util-angular/PhoneUtil';

export default ['LocaleService', function (LocaleService) {
    return function (number) {
        return PhoneUtil(LocaleService).prettyPrint(number);
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/filters/prettyPhoneNumber.js
// module id = 1035
// module chunks = 0